<template>
  <div class="wtv-tour-wrapper" @click.self="setTour(null)" ref="wrap">

    <div class="wtv-tour-content wtv-tour-content-row">
      <!-- <Loading
        v-if="isLoading('Actualizing tour')"
        code="Actualizing tour"
        class="wtv-tour-content"
      /> -->

      <div class="wtv-tour-main">
        <Loading

          v-if="isLoading('Actualizing tour')"
          code="Actualizing tour"
          class="wtv-tour-content"
        />
        <template v-else-if="tour">
          <div class="wtv-tour-head">
            <div
              class="wtv-tour-wrapper-close wtv-icon"
              @click="setTour(null)"
            ></div>

            <div class="wtv-tour-head-title">
              <div class="wtv-tour-hotelname">
                <span class="wtv-small" v-if="context === 'office'">{{
                  tour.operatorname
                }}</span>
                {{ tour.hotelname.toLowerCase() }}
              </div>
              <div class="wtv-tour-rate">
                <div class="wtv-stars">
                  <div
                    v-for="star in 5"
                    :key="star"
                    class="wtv-star wtv-icon"
                    :class="{ 'wtv-star-unchecked': star > tour.hotelstars }"
                  ></div>
                </div>
                <div
                  class="wtv-tour-rating wtv-icon"
                  v-if="hotel && hotel.rating > 3"
                >
                  {{ hotel.rating }}
                </div>
              </div>
            </div>
            <div class="wtv-tour-tourname" v-if="context === 'office'">
              {{ tour.tourname }}
            </div>

            <div class="wtv-tour-details">
              <div class="wtv-tour-info">
                <div class="wtv-tour-info-row">
                  <div class="wtv-tour-option wtv-tour-departurename wtv-icon">
                    {{ tour.departurename }}
                  </div>
                  <div class="wtv-tour-option wtv-tour-countryname wtv-icon">
                    {{ tour.countryname }}
                  </div>
                  <div class="wtv-tour-option wtv-tour-hotelregionname wtv-icon">
                    {{ tour.hotelregionname }}
                  </div>
                  <div
                    v-if="tour.visacharge"
                    class="wtv-tour-option wtv-tour-visacharge wtv-icon"
                  >
                    <span>
                      виза на чел:
                      <br />
                      <span
                        v-html="priceString(tour.visacharge)"
                      ></span>
                    </span>
                  </div>
                </div>
                <div class="wtv-tour-info-row">
                  <div class="wtv-tour-option wtv-tour-flydate wtv-icon">
                    {{ tour.flydate }}
                  </div>
                  <div class="wtv-tour-option wtv-tour-nights wtv-icon">
                    {{ tour.nights }}{{ tour.nights > 4 ? ' ночей' : ' ночи' }}
                  </div>
                  <div class="wtv-tour-option wtv-tour-adults wtv-icon">
                    {{ touristStringFrom(tour.adults, tour.child) }}
                  </div>
                  <div class="wtv-tour-option wtv-tour-meal wtv-icon">
                    {{ tour.meal }}
                  </div>
                </div>
              </div>

              <div class="wtv-tour-action">
                <div class="wtv-tour-price">
                  <div class="wtv-small">Цена за номер</div>
                  <div
                    class="wtv-price"
                    v-html="priceString(flightPrice())"
                  ></div>

                </div>
                <div class="wtv-tour-fuelcharge wtv-icon">
                  <div class="wtv-small">Топливный сбор</div>
                  <div
                    class="wtv-price"
                    v-html="priceString(flightFuelCharge())"
                  ></div>
                </div>
                <div
                  class="wtv-button-main"
                  @click="selectTab('flights')"
                  v-show="!isSelectedTab('flights') && context == 'office'"
                >
                  Продолжить
                </div>
                <div
                  class="wtv-button-main"
                  @click="selectTab('order')"
                  v-show="!isSelectedTab('order') && context !== 'office'"
                  data-stats="go_to_order_form"
                >
                  Продолжить
                </div>
              </div>
            </div>
          </div>
          <div class="wtv-tour-body">
            <div class="wtv-tour-tabs">
              <div
                class="wtv-tour-tab wtv-button-second"
                :class="{ 'wtv-active': isSelectedTab('hotel') }"
                @click="selectTab('hotel')"
              >
                Об отеле
              </div>
              <div
                v-if="hotel && hotel.coord1"
                class="wtv-tour-tab wtv-button-second"
                :class="{ 'wtv-active': isSelectedTab('map') }"
                @click="selectTab('map')"
              >
                На карте
              </div>
              <div
                v-if="departure"
                class="wtv-tour-tab wtv-button-second"
                :class="{ 'wtv-active': isSelectedTab('flights') }"
                @click="selectTab('flights')"
              >
                Перелеты
              </div>
              <div
                v-if="context !== 'office'"
                class="wtv-tour-tab wtv-button-second"
                :class="{ 'wtv-active': isSelectedTab('order') }"
                @click="selectTab('order')"
              >
                Заявка на тур
              </div>
            </div>
            <div class="wtv-tour-tabcontents">
              <div
                class="wtv-tour-tabcontent"
                :class="{ 'wtv-active': isSelectedTab('hotel') }"
              >
                <Loading
                  v-if="isLoading('Getting hotel info')"
                  code="Getting hotel info"
                />
                <Gallery
                  v-else-if="parseInt(hotel.imagescount) > 0"
                  :images="hotel.images.image"
                />
                <Details />
              </div>

              <div
                class="wtv-tour-tabcontent"
                :class="{ 'wtv-active': isSelectedTab('map') }"
              >
                <Map
                  v-if="
                    isSelectedTab('map') &&
                      hotel &&
                      hotel.coord1 &&
                      hotel.coord1 !== '0'
                  "
                  :latitude="parseFloat(hotel.coord1)"
                  :longitude="parseFloat(hotel.coord2)"
                  :countrycode="hotel.countrycode"
                  :id="tour.tourid"
                />
              </div>

              <div
                class="wtv-tour-tabcontent"
                :class="{ 'wtv-active': isSelectedTab('flights') }"
              >
                <Flights v-if="isSelectedTab('flights')" />
                <!-- <OfficeForm v-if="context === 'office'" /> -->
              </div>

              <div
                v-if="context !== 'office'"
                class="wtv-tour-tabcontent"
                :class="{ 'wtv-active': isSelectedTab('order') }"
              >
                <div v-if="isSent" class="wtv-feedback-form is-sent">
                  <div class="wtv-feedback-form-title">
                    Спасибо за обращение, {{ feedback.username }}!
                  </div>
                  <div class="wtv-feedback-response">
                    Наш менеджер свяжется с Вами в ближайшее время
                  </div>
                  <template v-if="context === 'main'">
                    <div class="wtv-feedback-response">
                      Подписывайтесь на нас в соцсетях, чтобы всегда быть в курсе
                      лучших предложений
                    </div>
                    <div class="wtv-feedback-socials">
                      <a
                        class="wtv-icon wtv-vk"
                        target="_blank"
                        href="http://vk.com/club36511729"
                      ></a>
                      <a
                        class="wtv-icon wtv-instagram"
                        target="_blank"
                        href="https://instagram.com/wellrussia/"
                      ></a>
                    </div>
                  </template>
                </div>
                <Form v-else />
              </div>
            </div>
          </div>

        </template>

      </div>

      <!-- <div class="wtv-tour-sidebar" v-if="relatedList.length > 0">
        <div class="wtv-tour-sidebar-title">Другие отели курорта</div>
        <HotelList :list="relatedList" :hasSelected="true"/>
      </div> -->

    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent, onMounted, onUnmounted, computed, reactive, ref,
} from 'vue';
import { useStore } from 'vuex';
// import HotelList from '@/components/HotelList.vue';
import Loading from '@/components/Loading.vue';
import Gallery from '@/components/Gallery.vue';
import Details from '@/components/Details.vue';
import Flights from '@/components/Flights.vue';
import Form from '@/components/Form.vue';
import Map from '@/components/Map.vue';
// import OfficeForm from '@/components/OfficeForm.vue';
// import {
//   mapState, mapMutations, mapGetters, mapActions,
// } from 'vuex';

export default defineComponent({
  name: 'Tour',
  components: {
    // HotelList,
    Loading,
    Map,
    Gallery,
    Details,
    Flights,
    Form,
    // OfficeForm,
  },
  setup() {
    const $store = useStore();
    const {
      isError,
      isLoading,
      priceString,
      context,
      hotelInfo, touristStringFrom, flightPrice, flightFuelCharge,
    } = $store.getters;
    const tour = computed(() => $store.state.tour);
    const isSent = computed(() => $store.state.isSent);
    const feedback = computed(() => $store.state.feedback);
    const hotel = computed(() => hotelInfo(tour.value.hotelcode));
    const relatedList = computed(() => $store.state.relatedList);

    const aboutRegion = computed(() => $store.state.initials.list[$store.state.cellIndex]);

    const departure = (window as {WTV_DEPARTURE?: boolean}).WTV_DEPARTURE;

    onMounted(() => {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    });
    onUnmounted(() => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    });

    const setTour = (newTour: unknown) => $store.commit('setTour', newTour);

    const reactiveData = reactive({
      tabSelected: 'hotel',
      tour,
    });
    const isSelectedTab = (tab: string) => reactiveData.tabSelected === tab;

    const wrap = ref({} as HTMLDivElement);
    // watchEffect(() => reactiveData.tour && (wrap.value).scroll(0, 0));

    const selectTab = (tab: string) => {
      reactiveData.tabSelected = tab;

      const e = window.event as Event;
      const type = (e.target as HTMLDivElement)?.dataset?.stats;
      if (type) {
        $store.dispatch('sendStats', {
          cell: $store.state.initials.list[$store.state.cellIndex],
          type: (e.target as HTMLDivElement)?.dataset?.stats,
        });
      }

      if (tab === 'order') {
        setTimeout(() => (document.querySelector('.wtv-form .wtv-form-submit') as Element).scrollIntoView({ behavior: 'smooth' }), 200);
      }

      if (tab === 'flights') $store.dispatch('actualizeDetail');
    };
    // data() {
    //   return {
    //     tabSelected: 'hotel',
    //   };
    // },
    // computed: {
    //   ...mapGetters([
    //     'isLoading',
    //     'touristStringFrom',
    //     'priceString',
    //     'flightPrice',
    //     'flightFuelCharge',
    //     'flightCurrency',
    //     'flightFuelChargeCurrency',
    //     'context',
    //   ]),
    //   ...mapState(['tour', 'hotel', 'sent', 'feedback']),
    //   isSelectedTab() {
    //     return (tab) => this.tabSelected === tab;
    //   },
    // },
    // methods: {
    //   ...mapMutations(['setTour']),
    //   ...mapActions(['actualizeDetail']),
    //   selectTab(tab) {
    //     this.tabSelected = tab;
    //     if (tab === 'flights') this.actualizeDetail();
    //   },
    // },
    return {
      // isInitialized,
      setTour,
      isError,
      isLoading,
      priceString,
      flightPrice,
      flightFuelCharge,
      touristStringFrom,
      context,
      tour,
      hotel,
      relatedList,
      aboutRegion,

      feedback,
      isSent,
      isSelectedTab,
      selectTab,
      departure,

      wrap,
    };
  },
});
</script>

<style scoped>
.wtv-tour-wrapper {
  z-index: 9000;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 50px 0;
  background-color: var(--color-text-5);
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: scroll;
  /* ios */

  height: -webkit-fill-available;
  -webkit-overflow-scrolling: touch;
}
.wtv-tour-wrapper-close {
  position: absolute;
  left: unset;
  top: 0;
  right: 0;
  cursor: pointer;
  padding: 8px 12px;
  background-color: var(--color-bg);
}
.wtv-tour-wrapper-close:before {
  width: 100%;
  content: '\f00d';
  text-align: center;
  color: var(--color-main);
  font-size: 18px;
}
@media (max-width: 575px) {
  .wtv-tour-wrapper-close {
    position: fixed;
    z-index: 9999;
    top: 8px;
    right: 28px;
  }
}
.wtv-tour-content {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  width: 100%;
  max-width: 1200px;
  border-radius: 4px;
  background-color: var(--color-paper);
  min-height: 60vh;
  position: relative;
}
.wtv-tour-content-row {
  flex-flow: row wrap;
  justify-content: stretch;
}
.wtv-tour-body {
  width: 100%;
  flex: 8;
}
.wtv-tour-sidebar {
  flex: 1;
  background-color: var(--color-bg);
}
@media(min-width: 575px) {
  .wtv-tour-sidebar {
    flex: 0;
    order: -1;
  }
}
.wtv-tour-sidebar-title {
  padding: 24px 12px;
}
.wtv-tour-main {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  flex: 2;
  width: 100%;
}
.wtv-tour-head {
  display: flex;
  flex-direction: column;
  width: 100%;
  /* flex: 0; */
}
.wtv-tour-head-title {
  padding: 8px 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding-bottom: 12px;
}
.wtv-tour-tourname {
  text-align: center;
  color: var(--color-text-5);
  margin: -4px 12px;
}
.wtv-tour-hotelname {
  text-transform: capitalize;
  font-size: 22px;
}
.wtv-tour-hotelname span {
  font-size: 15px;
}
.wtv-tour-head-destination {
  display: flex;
  flex-wrap: wrap;
}
.wtv-tour-fuelcharge {
  padding-left: 28px;
  position: relative;
}
.wtv-tour-fuelcharge:before {
  content: '\f52f';
  font-size: 18px;
  position: absolute;
  left: 0;
  top: 24px;
}

/* tour info */
.wtv-tour-details {
  display: flex;
  flex-wrap: wrap;
  /* padding: 12px 0; */
}
.wtv-tour-info {
  flex: 2;
  padding: 8px 18px;
}
.wtv-tour-info-row {
  padding: 8px 0 0;
  border-top: 1px solid var(--color-alt-5);
  display: flex;
  flex-wrap: wrap;
}
.wtv-tour-info-row:first-child {
  border: none;
}
.wtv-tour-action {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  padding: 8px 18px;
  min-width: 300px;
}
.wtv-tour-price {
  flex: 1;
}
.wtv-tour-fuelcharge {
  flex: 1;
}
.wtv-tour-option {
  flex: 1 0 100px;
  margin-right: 8px;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
}
.wtv-tour-option:before {
  font-size: 18px;
  margin-right: 8px;
  width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-alt-5);
}
.wtv-tour-departurename:before {
  content: '\f5b0';
}
.wtv-tour-countryname:before {
  content: '\f5af';
}
.wtv-tour-hotelregionname:before {
  content: '\f3c5';
}
.wtv-tour-adults:before {
  content: '\f500';
}
.wtv-tour-flydate:before {
  content: '\f783';
}
.wtv-tour-visacharge:before {
  content: '\f2c2';
}
.wtv-tour-nights:before {
  content: '\f186';
}
.wtv-tour-meal:before {
  content: '\f725';
}

/* tabs */
.wtv-tour-tabs {
  display: flex;
}
.wtv-tour-tab {
  border-radius: 0;
}
.wtv-tour-tab.wtv-active {
  background-color: var(--color-paper);
  border-top: 8px solid var(--color-alt-5);
  margin-top: 4px;
  border-bottom: 0;
  padding-top: 0;
}
.wtv-tour-tabcontent {
  display: none;
}
.wtv-tour-tabcontent.wtv-active {
  display: flex;
  flex-direction: column;
}

/* stars */
.wtv-stars {
  display: flex;
  margin-right: 8px;
  margin-left: 8px;
}
.wtv-star,
.wtv-star-unchecked {
  margin-right: 2px;
  cursor: pointer;
}
.wtv-star-unchecked:before,
.wtv-star:before {
  content: '\f005';
  font-size: 14px;
}
.wtv-star:before {
  color: var(--color-third);
}
.wtv-star-unchecked:before {
  color: var(--color-alt-5);
}

/* rating */
.wtv-tour-rate {
  display: flex;
  padding-top: 4px;
}
.wtv-tour-rating {
  background-color: var(--color-bg);
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 12px;
}
.wtv-tour-rating:before {
  content: '\f581';
  color: var(--color-alt);
  margin-right: 8px;
}

/* response */
.wtv-feedback-form {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: center;
  flex-wrap: wrap;
  padding: 32px 24px;
  background-color: var(--color-bg);
  flex: 1 1 300px;
}
.wtv-feedback-form-title {
  font-size: 18px;
  padding: 0 8px 8px;
  width: 100%;
  text-align: center;
}
.wtv-feedback-response {
  padding: 12px 8px;
  text-align: center;
}
.wtv-feedback-socials {
  display: flex;
}
.wtv-vk,
.wtv-instagram {
  margin: 8px;
  background-color: var(--color-main);
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
}
.wtv-vk:before,
.wtv-instagram:before {
  content: '\f189';
  width: 100%;
  font: 28px 'Font Awesome 5 Brands';
  color: #fff;
  text-align: center;
}
.wtv-instagram:before {
  content: '\f16d';
  font-size: 32px;
}
.wtv-icon-card:before {
  content: '\f09d';
  margin-right: 12px;
  color: #fff;
  font-size: 18px;
}
</style>
